import { Button, notification, Tooltip } from "antd";
import { useCallback, useContext, useState } from "react";
import { useParams } from "react-router";
import { ErrorMessages, ProjectPermissionEnum } from "constants/index";
import {
  isPermissionNotGrantted,
  ProjectContext
} from "context/ProjectProvider";
import CreateDesignPackageComponent from "./components/create-design-package";
import PlannerCardView from "./components/planner-card-view";

function DesignPackageLogPage() {
  const { tokenContents } = useContext(ProjectContext);

  const cannotWriteAccessOfDesignPackage = isPermissionNotGrantted(
    ProjectPermissionEnum.DesignPackageWrite,
    tokenContents?.role ?? ""
  );

  const [cardRefreshKey, setCardRefreshKey] = useState(0);
  const refreshCardLog = useCallback(() => setCardRefreshKey((n) => n + 1), []);

  const [showDrawer, setShowDrawer] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const { projectId } = useParams() as { projectId: string };

  const openNotification = (title: string) => {
    api.open({
      message: `${title} successfully created.`,
      placement: "top"
    });
  };

  const addButton = (
    <Tooltip
      title={
        cannotWriteAccessOfDesignPackage
          ? ErrorMessages.PermissionNotGranted
          : undefined
      }
    >
      <span className="inline-flex">
        <Button
          type="primary"
          data-testid="index-button-new-design-package"
          disabled={cannotWriteAccessOfDesignPackage}
          onClick={() => setShowDrawer(true)}
        >
          Add New
        </Button>
      </span>
    </Tooltip>
  );

  return (
    <>
      {contextHolder}
      <PlannerCardView
        projectId={projectId}
        addButton={addButton}
        refreshKey={cardRefreshKey}
        canAdd={!cannotWriteAccessOfDesignPackage}
        onAddDesignPackage={() => setShowDrawer(true)}
      />
      <CreateDesignPackageComponent
        setDrawerOpen={setShowDrawer}
        showDrawerOpen={showDrawer}
        modelTitle="Create Design Package"
        onDesignPackageCreated={(title: string) => {
          setShowDrawer(false);
          openNotification(title);
          refreshCardLog();
        }}
      />
    </>
  );
}

export default DesignPackageLogPage;
